import { render } from "./PositionEditor.vue?vue&type=template&id=5f4f79eb"
import script from "./PositionEditor.vue?vue&type=script&lang=js"
export * from "./PositionEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__